<template>
  <div class="EscuelaFotos">
    <md-card v-if="isOnline">
      <md-card-header>
        <md-card-header-text>
          <div class="md-title">Fotografías</div>
        </md-card-header-text>
      </md-card-header>
      <md-card-content>
        <md-field>
          <label v-text="'Seleccionar fotografía'" />
          <md-file
            v-model="foto"
            accept="image/jpeg, image/jpg, image/png"
            @md-change="_addFile($event)"
            :disabled="cargandoFoto"
          />
          <span
            class="md-helper-text"
            v-if="!cargandoFoto"
            v-text="'Una vez seleccionada la fotografía, será cargada automáticamente'"
          />
        </md-field>
        <md-progress-bar
          v-if="cargandoFoto"
          md-mode="indeterminate"
        />
      </md-card-content>
      <md-list class="md-double-line">
        <div
          v-for="(img,i) in imagenesEscuela"
          :key="img.id"
        >
          <md-list-item>
            <md-button
              class="md-icon-button md-dense"
              :href="$http.options.root +'/'+ img.ruta_fot"
              target="_blank"
            >
              <md-icon class="md-primary">link</md-icon>
            </md-button>
            <div class="md-list-item-text">
              <span>{{img.ruta_fot.split('/').pop()}}</span>
              <span>{{img.created_fot}}</span>
            </div>
          </md-list-item>
          <md-divider v-if="i+1 < imagenesEscuela.length" />
        </div>
      </md-list>
      <md-card-actions v-if="imagenesEscuela">
        <md-button
          :href="$http.options.root +'/fotos/descargar/'+ escuela.id"
          target="_blank"
        >
          <md-icon class="md-primary">cloud_download</md-icon> Descargar fotografías
        </md-button>
      </md-card-actions>
    </md-card>
    <Loading v-if="cargando" />
  </div>
</template>
<script>
import falloResponse from "@/mixins/falloResponse.js";
export default {
  name: "EscuelaFotos",
  props: { escuela: Object },
  mixins: [falloResponse],
  components: { Loading: () => import("@/components/Loading.vue") },
  methods: {
    _getFotos() {
      this.$http.get("fotos/" + this.escuela.id, this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 200 && "fotos" in res.body) {
            this.imagenesEscuela = res.body.fotos;
          } else {
            this._falloResponse(res);
          }
        },
        err => {
          this._falloResponse(err);
        }
      );
    },
    _addFile(f) {
      if (f) {
        let formData = new FormData();
        formData.append("foto", f[0]);
        formData.append("escuela", this.escuela.id);
        this.cargando = true;
        this.cargandoFoto = true;
        this.$http.post("fotos", formData, this.$headers).then(
          res => {
            this.cargando = false;
            this.cargandoFoto = false;
            if (res.status === 401) {
              this.$router.push("/login");
            } else if (res.status === 201 && "msg" in res.body) {
              this.imagenesEscuela.unshift({
                id_esc_fot: res.body.id_esc_fot,
                id_fot: res.body.id_fot,
                ruta_fot: res.body.ruta_fot,
                created_fot: res.body.created_fot
              });
              this.$emit("msg", res.body.msg);
            } else {
              this._falloResponse(res);
            }
          },
          err => {
            this.cargando = false;
            this.cargandoFoto = false;
            this._falloResponse(err);
          }
        );
      }
    }
  },
  data() {
    return {
      idEsc: null,
      buscar: null,
      fotos: [],
      foto: null,
      fotoFile: null,
      cargando: false,
      cargandoFoto: false,
      imagenesEscuela: []
    };
  },
  watch: {
    isOnline(a) {
      if (a && this.escuela.id) {
        this._getFotos();
      }
    },
    escuela() {
      if (this.isOnline && this.escuela.id) {
        this._getFotos();
      }
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  }
};
</script>